export function stripGroupingFromAmountDisplay(formatted: string): string {
  return formatted.replace(/,/g, '');
}

/** `undefined` means mid-edit (e.g. "-" only); do not push to parent yet. */
export function liveParsedDecimal(raw: string): number | null | undefined {
  const cleaned = raw.replace(/[^0-9.-]/g, '');
  if (cleaned === '') return null;
  if (cleaned === '-' || cleaned === '.' || cleaned === '-.') return undefined;
  const n = Number.parseFloat(cleaned);
  return Number.isFinite(n) ? n : null;
}

export function commitDecimalString(raw: string): number | null {
  const cleaned = raw.replace(/[^0-9.-]/g, '');
  if (cleaned === '' || cleaned === '-' || cleaned === '.' || cleaned === '-.') return null;
  const n = Number.parseFloat(cleaned);
  return Number.isFinite(n) ? n : null;
}
